export default {
  title: 'Rinomina offerta',
  subtitle: "Inserisci un nuovo nome per l'offerta (massimo 40 caratteri)",
  toasts: {
    success: 'Offerta rinominata con successo',
    error: "Rinomina dell'offerta non riuscita",
  },
  buttons: {
    rename: 'Rinomina',
  },
  form: {
    title: {
      label: 'Nome offerta',
      placeholder: 'Inserisci nome offerta',
    },
  },
};
